import { AIModel } from '../../types/AIModels';
import { RAGMode } from '../../types/RAGModes';
import { QueryType } from '../../types/QueryTypes';
import { ChatRole } from '../../types/ChatRoles';

export enum ChunkType {
  Text = 'text',
  Table = 'table',
  Image = 'image',
}

export enum ChatBlockType {
  Text = 'text',
}

export enum ChatMessageType {
  Thinking = 'thinking',
  Chat = 'chat',
}

/**
 * Status values for a conversation
 * - inactive: default state or when user has seen all messages
 * - answering: backend has received the message and is processing
 * - new_answer: backend has responded but user hasn't seen it yet
 * - error: an error occurred during processing
 */
export enum ConversationStatus {
  Inactive = 'inactive',
  Answering = 'answering',
  NewAnswer = 'new_answer',
  Error = 'error',
}

export interface ClientChatSource {
  id: string;
  similarity: number;
  content: string;
  document_id: string;
  file_name: string;
  calendar_year?: number;
  chunk_number: number;
  chunk_type: ChunkType;
  page_id?: string;
  section_id?: string;
  section_header?: string;
}

export interface ClientChatBlock {
  sequence: number;
  type: ChatBlockType;
  content: string | null;
  sources: ClientChatSource[];
}

/**
 * Status for messages showing delivery/read/error status
 */
export enum MessageStatus {
  Sending = 'sending', // Message sending to server
  Sent = 'sent', // Message sent to server
  Seen = 'seen', // Server has seen and is processing
}

export interface ClientMessage {
  timestamp: string; // ISO string
  role: ChatRole;
  sequence: number;
  blocks: ClientChatBlock[];
  sources?: ClientChatSource[];
  status?: MessageStatus; // Only applicable for user messages, frontend only
  type: ChatMessageType;
}

export interface ClientConversation {
  id: string;
  user_id: string;
  title: string | null;
  created_at: string;
  updated_at: string;
  status: ConversationStatus;
  is_deleted?: boolean;
  filtered_company_ids?: string[];
  filtered_company_tickers?: string[];
  messages: ClientMessage[];
  thinkingMessage?: {
    sequence: number;
    thinkingStatus: string;
  };
}

export interface ConversationPreview {
  id: string;
  title: string | null;
  created_at: string;
  updated_at: string;
  status: ConversationStatus;
  is_deleted?: boolean;
  filtered_company_ids?: string[];
  filtered_company_tickers?: string[];
}

export interface FormValues {
  model?: AIModel;
  topK?: number;
  ragMode?: RAGMode;
  relevancePercent?: number;
  traceTag?: string;
  forceQueryType?: QueryType;
  filteredCompanyIds?: string[];
}
